import {get} from "./axios";
import {ResUser} from "../../../types/user";

const baseUrl = '/api/users';

export const getCurrentUser = async (): Promise<ResUser> => {
    const res = await get(`${baseUrl}/current-user`);
    return res.data as ResUser
};
